/* eslint-disable react/no-array-index-key */
import { ContactFormulierPage } from "@page/contact-formulier";
import axios from "axios";
import { PiletApi } from "opencak-app";
import * as React from "react";
import { interceptors } from "./interceptors/Interceptors";
import "./sass/cbhc.scss";

export function setup(app: PiletApi) {
  const basePath = app.getData("base-path");
  const apiUrl = app.getData("api-path");
  const authEnabled = app.getData("api-auth-enabled");
  const Layout = app.getFormPageLayoutComponent();

  axios.defaults.withCredentials = authEnabled;

  const ContactFormulierPageForm = (curentLanguage: string) => () => {
    React.useEffect(() => {
      interceptors.initialize(axios, curentLanguage);
    }, []);
    return (
      <Layout>
        <div className="formulier-page-container formulier-page-container--cbhc">
          <ContactFormulierPage
            language={curentLanguage}
            pageBaseUrl={`${basePath}/cbhc/contact/${curentLanguage}`}
            apiUrl={apiUrl}
          />
        </div>
      </Layout>
    );
  };

  app.registerPage(`${basePath}/cbhc/contact/nl/:formStep?`, ContactFormulierPageForm("nl"));
  app.registerPage(`${basePath}/cbhc/contact/en/:formStep?`, ContactFormulierPageForm("en"));
}
